import { render, staticRenderFns } from "./MetasPorSku.vue?vue&type=template&id=9e1871c8&scoped=true"
import script from "./MetasPorSku.vue?vue&type=script&lang=js"
export * from "./MetasPorSku.vue?vue&type=script&lang=js"
import style0 from "./MetasPorSku.vue?vue&type=style&index=0&id=9e1871c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e1871c8",
  null
  
)

export default component.exports